'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import { NETWORK_OFFLINE, THREAD_HISTORY_FAILED, CREATE_NEW_THREAD_FAILED, SUBSCRIPTIONS_FAILED, PUBSUB_FAILED } from '../constants/networkErrors';
import { isFailed } from 'conversations-async-data/async-data/operators/statusComparators';
import { getError } from 'conversations-async-data/async-data/operators/getters';
import { getAsyncStagedThread } from '../../thread-create/selectors/stagedThreadSelectors';
import { getAsyncPubSubClient } from 'conversations-internal-pub-sub/redux/selectors/pubSubClientGetters';
import { getCurrentThreadHistoryEntry } from '../../thread-history/selectors/getCurrentThreadHistoryEntry';
const isConnected = state => state.clientData.isPubNubClientConnected;
const getAsyncSubscriptions = get('subscriptions');
export const getNetworkErrors = createSelector([getCurrentThreadHistoryEntry, getAsyncStagedThread, getAsyncSubscriptions, getAsyncPubSubClient, isConnected], (asyncThreadHistory, asyncStagedThread, asyncSubscriptions, asyncPubSubClient, connected) => {
  if (isFailed(asyncThreadHistory)) {
    return THREAD_HISTORY_FAILED;
  }
  if (isFailed(asyncStagedThread)) {
    const error = getError(asyncStagedThread);
    // https://issues.hubspotcentral.com/projects/CT/issues/CT-335
    // A 418 status means the visitor is blocked, so we don't want to show this error
    const isBlockedError = error && error.status === 418;
    if (!error || !isBlockedError) {
      return CREATE_NEW_THREAD_FAILED;
    }
  }
  if (isFailed(asyncSubscriptions)) {
    return SUBSCRIPTIONS_FAILED;
  }
  if (isFailed(asyncPubSubClient)) {
    return PUBSUB_FAILED;
  }
  if (!connected) {
    return NETWORK_OFFLINE;
  }
  return null;
});